import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

export default function PaymentSuccess() {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-success bg-opacity-10 px-3">
      <div className="card shadow-lg border-0 rounded-4 text-center p-4">
        <div className="card-body">
          <FontAwesomeIcon icon={faCheckCircle} className="text-success display-1 mb-3" />
          <h1 className="h3 text-success">Payment Successful!</h1>
          <p className="text-muted">
            Your booking is confirmed. Check your email or booking history for details.
          </p>
          <button
            onClick={() => navigate('/my-bookings')}
            className="btn btn-success mt-3 px-4"
          >
            View Booking
          </button>
        </div>
      </div>
    </div>
  );
}
